import { Delete, Pencil } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

interface DropdownActions {
  canEdit: boolean | undefined
  canDelete: boolean | undefined
  onEdit: () => void
  onDelete: () => void
}

export function buildDropdownItems({ canEdit, canDelete, onEdit, onDelete }: DropdownActions) {
  const items: { label: string; icon?: typeof Pencil; onClick: () => void; critical?: boolean }[] =
    []

  if (canEdit) {
    items.push({
      label: i18n.t('common.edit'),
      icon: Pencil,
      onClick: onEdit,
    })
  }

  if (canDelete) {
    items.push({
      label: i18n.t('performance_goals.metric_row.delete'),
      icon: Delete,
      onClick: onDelete,
      critical: true,
    })
  }

  return items
}
